export const BILLING_CATEGORY = "v1/billing-categories";
